module.exports = __webpack_public_path__ + "img/0Q3B2213_Black_MockedUp.cfeea9d7.jpg";